export default {"src":"/_next/static/media/excited.5e7c0a6b.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};